module.exports = __webpack_public_path__ + "static/media/ramlab.82e4162e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ramlab.webp
// module id = 866
// module chunks = 0